import { allDamTypes } from 'app/agriculture/queries/entities/types/infrastructure/DamType';
import { useFormContext } from 'react-hook-form';
import { Select } from 'app/agriculture/forms/components/Select/Select';

export function DamFields() {
    const form = useFormContext();

    return (
        <Select
            fieldName="damType"
            options={allDamTypes.map((damType) => ({
                id: damType,
                name: damType,
            }))}
            noun="Type"
            formController={form}
        />
    );
}
